var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "18px",
    viewBox: "0 0 13 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\uD83D\uDCF7 Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pharmacy-Selection",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mobile---Search-by-address",
    transform: "translate(-225.000000, -766.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "FILTER-AND-MAP",
    transform: "translate(0.000000, 727.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "FILTER-AND-MAP-BUTTONS",
    transform: "translate(37.000000, 26.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Buttons/Text-and-Icon/blue/default",
    transform: "translate(158.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "alignment-group",
    transform: "translate(26.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-+-label",
    transform: "translate(52.852941, 12.000000) rotate(180.000000) translate(-52.852941, -12.000000) translate(0.352941, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, -0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/place",
    transform: "translate(95.000000, 13.000000) rotate(180.000000) translate(-95.000000, -13.000000) translate(85.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.77434896,17.9970663 C5.04459635,11.1403297 4.16666667,10.436619 4.16666667,7.91666514 C4.16666667,4.46487562 6.9648763,1.66666667 10.4166667,1.66666667 C13.868457,1.66666667 16.6666667,4.46487562 16.6666667,7.91666514 C16.6666667,10.436619 15.788737,11.1403297 11.0589844,17.9970663 C10.7486003,18.4454386 10.0847005,18.4454061 9.77434896,17.9970663 Z M10.4166667,10.5208312 C11.8549154,10.5208312 13.0208333,9.35491349 13.0208333,7.91666514 C13.0208333,6.47841679 11.8549154,5.31249911 10.4166667,5.31249911 C8.97841797,5.31249911 7.8125,6.47841679 7.8125,7.91666514 C7.8125,9.35491349 8.97841797,10.5208312 10.4166667,10.5208312 Z",
    id: "Shape"
  }))))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.4e0d614f5f56af0257e49a271610ab88.svg";
export { ForwardRef as ReactComponent };